module.exports = __webpack_public_path__ + "img/foreground-desktop.c565245.png";